// 定义中文简体语言包对象
export default {
  Language: '中文简体',
  // 导航栏
  nav_cashier: '收银台',
  
  // 支付收银台
  payment_title: '支付收银台',
  payment_amount_label: '请输入支付金额',
  payment_method_title: '选择支付方式',
  payment_method_wechat: '微信支付',
  payment_method_alipay: '支付宝',
  payment_method_unionpay: '银联',
  payment_button: '立即支付 HK${amount}',
  payment_loading: '支付中...',
  
  // 支付调起页面
  payment_password_title: '请输入支付密码',
  payment_password_placeholder: '请输入6位支付密码',
  payment_password_hint: '请在{paymentMethod}中输入支付密码',
  payment_cancel: '取消',
  payment_confirm: '确认支付',
  
  // 支付成功提示
  payment_success: '支付成功',
  payment_amount: '支付金额：',
  payment_method: '支付方式：',
  payment_transaction_id: '交易号：',
  payment_time: '支付时间：',
  payment_ok: '确定',
  
  // 弹窗提示
  payment_amount_error: '请输入有效的支付金额',
  payment_password_error: '请输入6位支付密码',
  payment_error: '支付初始化失败',
  payment_request_error: '支付请求失败，请稍后重试',
  
  // 银联支付
  unionpay_scan_title: '银联二维码支付',
  unionpay_scan_hint: '请下载二维码后使用云闪付APP扫码支付',
  unionpay_download_button: '下载二维码',
  unionpay_download_success: '二维码已保存到相册',
  unionpay_download_failed: '下载失败，请重试',
  unionpay_mobile_save_hint: '长按图片，选择"保存图片"即可',
  unionpay_desktop_save_hint: '请在新窗口中右键保存图片',
  unionpay_mobile_long_press: '长按保存图片'
};